import { render, staticRenderFns } from "./async.vue?vue&type=template&id=6455fafe&"
import script from "./async.vue?vue&type=script&lang=js&"
export * from "./async.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports